class AwardsWinnerData {
  category = '';

  title = '';

  product = '';

  advertiser= '';

  city = '';

  awards = '';

  constructor(data) {
    this.category = data.category;
    this.title = data.title;
    this.product = data.product;
    this.advertiser = data.advertiser;
    this.city = data.city;
    this.awards = data.awards;
  }

  static fromObject(data) {
    return new AwardsWinnerData(data);
  }

  static fromList(list) {
    return (list || []).map(AwardsWinnerData.fromObject);
  }
}

export default AwardsWinnerData;
